import { useCallback, useEffect, useState } from 'react';

import {
  isNotificationDismissed,
  setNotificationDismissed,
  setNotificationRead,
} from 'components/Pages/GuestPortal/LandingLayout/functions';

import { ITourTooltipProps } from './types';

export const useTourTooltip = ({ notifications, steps }: Pick<ITourTooltipProps, 'notifications' | 'steps'>) => {
  const [notificationToShow = { id: '0', contextId: 'any', isRead: true }] = notifications;
  const showInit = !notificationToShow.isRead;
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState<number>(1);

  const handleToggleShowPopup = useCallback(
    (needToSetNotificationRead = true) => {
      setShowPopup(!showPopup);
      setActiveStep(1);
      if (needToSetNotificationRead) {
        setNotificationRead(notificationToShow);
      }

      setNotificationDismissed(notificationToShow);
    },
    [showPopup, notificationToShow],
  );

  const buttonHandler = () => {
    if (activeStep < steps) {
      setActiveStep((prev) => prev + 1);
    } else {
      setShowPopup(false);
      setNotificationRead(notificationToShow);
    }
  };

  useEffect(() => {
    if (showInit && !isNotificationDismissed(notificationToShow)) {
      setTimeout(() => {
        setShowPopup(true);
      }, 2000);
    }
  }, []);

  return {
    activeStep,
    setActiveStep,
    showPopup,
    handleToggleShowPopup,
    buttonHandler,
  };
};
